import { render, staticRenderFns } from "./clipper-preview.vue?vue&type=template&id=4989d8cb&scoped=true&"
import script from "./clipper-preview.vue?vue&type=script&lang=js&"
export * from "./clipper-preview.vue?vue&type=script&lang=js&"
import style0 from "./clipper-preview.vue?vue&type=style&index=0&id=4989d8cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.10.0_68125b3067bc9264b7f5e63a32c23d52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4989d8cb",
  null
  
)

export default component.exports